module.exports = __webpack_public_path__ + "media/svg/interviews-6f8c60be.svg";